
const validate = {
    function (type, value) {
        let REG;
        switch (type) {
            case 'INT': {
                REG = /^[1-9]*[1-9][0-9]*$/;
                break;
            }
            case 'PHONE':
                REG = /^(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[5678]|16[6]|19[89])[0-9]{8}$/;
                break;
            case 'CODE':
                REG = /^[0-9]{6}$/;
                break;
            case 'PASSWORD':
                if (value.length < 6 || value.length > 20) {
                    return false;
                }
                if (/[a-z]/.test(value)
                    && /[A-Z]/.test(value)
                    && /[0-9]/.test(value)) {
                    return true;
                }
                return false;
            case 'USERNAME': {
                const REG_NUM = /^[0-9]+$/;
                const REG_0 = /^[0-9A-Za-z]{6,20}$/;
                if (REG_0.test(value) && !REG_NUM.test(value)) {
                    return true;
                }
                return false;
            }
            case 'NAME':
                value = value.replace(/-/g, '');
                REG = /^[A-Za-z\u4E00-\u9FA5]{2,20}$/;
                break;
            case 'TELEPHONE':
                //  匹配形如0813-2208529
                REG = /^(0\d{2,3})-\d{7,8}$|^(0[1-9]{3}-(\d{7,8}))$/;
                if (value.substr(0, 1) === '4') {
                    //  匹配形如400-626-7751 或  匹配形如4007-626-775
                    REG = /^400-\d{3}-\d{4}$|^400\d-\d{3}-\d{3}$/;
                } else if (value.substr(0, 1) === '9') {
                    //  匹配形如952149
                    REG = /^9521\d{2}$/;
                }
                break;
            case 'ALLPHONE':
                REG = /^[0-9(?:(?!\-\-)]{0,12}$/;
                break;
            case 'EMAIL':
                REG = /^[a-z]([a-zA-Z0-9_]{5,20})@([a-z0-9]{1,10})([.]{1})([a-z]{2,4})$/;
                break;
            case 'PLATE_NUMBER':
                REG = /^((测[0-9A-Z]{6})|((冀[A-HJRT])|(豫[A-HJ-NP-SU])|(云[AC-HJ-NP-S])|(辽[A-HJ-NP])|(黑[A-HJ-NPR])|(湘[A-HJ-NUS])|(皖[A-HJ-NPRS])|(鲁[A-HJ-NP-SU-WY])|(新[A-HJ-NPQR])|(苏[A-HJ-N])|(浙[A-HJKL])|(赣[A-HJ-M])|(鄂[A-HJ-NP-S])|(桂[A-HJ-NPR])|(甘[A-HJ-NP])|(晋[A-FHJ-M])|(蒙[A-HJ-M])|(陕[A-HJKV])|(吉[A-HJK])|(闽[A-HJK])|(贵[A-HJ])|(粤[A-HJ-NP-Z])|(川[A-HJ-MQ-Z])|(青[A-H])|(藏[A-HJ])|(琼[A-F])|(宁[A-E])|(渝[A-Z])|(京[A-Z])|(津[A-Z])|(沪[A-Z]))(([0-9A-HJ-NP-Z]{4}[0-9A-HJ-NP-Z领警港澳学挂]))|(WJ[冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤川青藏琼宁渝京津沪][0-9A-Z]{5}))$/;
                break;
            // no default
        }
        return REG.test(value);
    }
}
export default validate;



// WEBPACK FOOTER //
// ./src/utils/validate.js